import useColorPickerAddColor from './useColorPickerAddColor';

export default useColorPickerAddColor;